// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3hAFz","colMin":"styles_colMin__3SC7U"};